import ScrollToHash from './ScrollToHash';

export default ScrollToHash;
